import {lazyRegister} from "@/Core/lazyRegister";

lazyRegister.filter('skufilter', function () {
    return function (input, query) {
        if (query) {
            return input.filter(function (element) {
                return element.toLowerCase().indexOf(query.toLowerCase().replace('-', '')) > -1;
            });
        }
        return input;
    };
});

lazyRegister.filter('skuApply', function () {
    return function (input) {
        return input ? input.substring(0, 5) + '-' + input.substring(5, 8) : input;
    };
});